import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle, DollarSign } from 'lucide-react';

export default function InadimplentesPage() {
  const [inadimplentes, setInadimplentes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/gestor/inadimplentes').then(r => setInadimplentes(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6 animate-fadeIn" data-testid="inadimplentes-page">
      <div className="flex items-center gap-3">
        <AlertTriangle className="w-7 h-7 text-red-400" />
        <h1 className="text-3xl font-black font-['Barlow_Condensed'] tracking-tight uppercase text-white">INADIMPLENTES</h1>
      </div>

      <Card className="bg-[#141414] border-[#27272A]">
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow className="border-[#27272A] hover:bg-transparent">
                <TableHead className="text-zinc-400">Aluno</TableHead>
                <TableHead className="text-zinc-400">Email</TableHead>
                <TableHead className="text-zinc-400">Mensalidades Atrasadas</TableHead>
                <TableHead className="text-zinc-400">Valor Pendente</TableHead>
                <TableHead className="text-zinc-400">Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {loading ? (
                <TableRow><TableCell colSpan={5} className="text-center text-zinc-500 py-8">Carregando...</TableCell></TableRow>
              ) : inadimplentes.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} className="text-center py-12">
                    <div className="flex flex-col items-center gap-2">
                      <div className="w-12 h-12 rounded-full bg-green-500/10 flex items-center justify-center">
                        <DollarSign className="w-6 h-6 text-green-400" />
                      </div>
                      <p className="text-zinc-400">Nenhum aluno inadimplente</p>
                      <p className="text-zinc-600 text-sm">Todos os alunos estao em dia!</p>
                    </div>
                  </TableCell>
                </TableRow>
              ) : inadimplentes.map(a => (
                <TableRow key={a.id} className="border-[#27272A] hover:bg-[#1C1C1E]" data-testid={`inadimplente-row-${a.id}`}>
                  <TableCell className="text-white font-medium">{a.name}</TableCell>
                  <TableCell className="text-zinc-400">{a.email}</TableCell>
                  <TableCell>
                    <Badge className="bg-red-500/10 text-red-400 border-red-500/20">{a.mensalidades_atrasadas}</Badge>
                  </TableCell>
                  <TableCell className="text-red-400 font-medium">R$ {a.valor_pendente?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</TableCell>
                  <TableCell><Badge variant="destructive" className="bg-red-500/10 text-red-400 border-red-500/20">Inadimplente</Badge></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
